export default {
  data() {
    return {
      token: null
    };
  },
  watch: {
    token(val) {
      if (val) {
        this.$cookies.set('members_token', val);
        window.sessionStorage.setItem('EXTRA_MEMBER_TOKEN', val);
        this.$axios.setHeader('Authorization', `Bearer ${val}`);
      } else {
        this.logOut();
      }
    }
  },
  mounted() {
    this.$cookies.remove('members_phone');
    this.token = this.$cookies.get('members_token') || window.sessionStorage.getItem('EXTRA_MEMBER_TOKEN');
  },
  methods: {
    logOut() {
      this.$cookies.remove('members_token');
      window.sessionStorage.removeItem('EXTRA_MEMBER_TOKEN');
      this.$router.push('/members/login');
    }
  }
};